module.exports = __webpack_public_path__ + "static/media/air_loading.6cfb9494.gif";